import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('dataFlowMonitoringConfigStore')
@observer
class dataFlowMonitoringConfig extends Component {
  render() {
    const { dataFlowMonitoringConfigStore, location } = this.props
    const { isFetching } = dataFlowMonitoringConfigStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default dataFlowMonitoringConfig;
